export default __webpack_public_path__ + "344bd4dcd9761305f4098fd9a63b8e2a.svg";